export const TenantConfigurationDefault = 1;
export const TenantConfigurationBelgium = 1;
export const TenantConfigurationNetherlands = 5;

export const isBelgianTenantConfiguration = tenantConfiguration =>
  tenantConfiguration === TenantConfigurationDefault ||
  tenantConfiguration === TenantConfigurationBelgium;

export const isDutchTenantConfiguration = tenantConfiguration =>
  tenantConfiguration === TenantConfigurationNetherlands;
